module.exports = __webpack_public_path__ + "media/components/country-flag/static/ta-d759ebdc3ac045f011813852f9bdb227.svg";